export const computeContrasts = (mmis: number[]) => {
  let contrasts: number[] = [];
  for (let i = 0; i < mmis.length; i += 3) {
    let maxMmi = Math.max(...mmis.slice(i, i + 3));
    let minMmi = Math.min(...mmis.slice(i, i + 3));
    let contrast = ((maxMmi - minMmi) * 100) / (maxMmi + minMmi);
    contrasts.push(contrast);
  }
  return contrasts;
};
